import React from "react";
import { useTranslation } from "react-i18next";

import languages from "../../common/languages";
import "./LanguageDropdown.css";

// Segmented switch between 繁體中文 and English.
// The choice is saved in localStorage by i18n.js.
// variant "light" is for dark backgrounds (login pages).
const LanguageDropdown = ({ variant = "default" }) => {
  const { t, i18n } = useTranslation();
  const current = i18n.language === "en" ? "en" : "zh-TW";

  return (
    <div
      className={`language-switch language-switch--${variant}`}
      role="group"
      aria-label={t("nav.switchLanguage")}
    >
      {Object.keys(languages).map((lng) => (
        <button
          key={lng}
          type="button"
          className={`language-switch__option${
            current === lng ? " is-active" : ""
          }`}
          aria-pressed={current === lng}
          title={languages[lng].label}
          onClick={() => i18n.changeLanguage(lng)}
        >
          {languages[lng].shortLabel}
        </button>
      ))}
    </div>
  );
};

export default LanguageDropdown;
